import React from 'react'
import Modal from 'presentation/hospital/components/Modal'
import * as S from './styles'
import ButtonNew from 'presentation/shared/components/ButtonNew'
import { ReactComponent as GuidesUnvailableImage } from 'presentation/assets/images/guides-unvailabem.svg'

type GuidesUnavailableModalProps = {
  close: () => void
}

export const GuidesUnvaibleModal = ({ close }: GuidesUnavailableModalProps) => {
  return (
    <Modal>
      <S.Container>
        <S.Title>Tente novamente mais tarde.</S.Title>
        <S.Subtitle>
          Infelizmente ainda está ocorrendo uma instabilidade e não foi possível
          gerar as guias.
        </S.Subtitle>

        <S.ImageContainer>
          <GuidesUnvailableImage />
        </S.ImageContainer>
      </S.Container>
      <S.ButtonContainer>
        <ButtonNew fullWidth={false} onClick={close}>
          Ok, vou tentar mais tarde
        </ButtonNew>
      </S.ButtonContainer>
    </Modal>
  )
}
